export default __webpack_public_path__ + "static/media/e13.e2352a67.jpg";